export default __webpack_public_path__ + "assets/a537566954c524019de2232d0409b2e7.jpg";